const getYoutubeId = (url, opts) => {
  if (opts === undefined) {
    opts = { fuzzy: true }
  }

  if (/youtu\.?be/.test(url)) {
    var i
    var patterns = [
      /youtu\.be\/([^#\&\?]{11})/,
      /\?v=([^#\&\?]{11})/,
      /\&v=([^#\&\?]{11})/,
      /embed\/([^#\&\?]{11})/,
      /\/v\/([^#\&\?]{11})/
    ]

    for (i = 0; i < patterns.length; ++i) {
      if (patterns[i].test(url)) {
        return patterns[i].exec(url)[1]
      }
    }

    if (opts.fuzzy) {
      var tokens = url.split(/[\/\&\?=#\.\s]/g)
      for (i = 0; i < tokens.length; ++i) {
        if (/^[^#\&\?]{11}$/.test(tokens[i])) {
          return tokens[i]
        }
      }
    }
  }

  return null
}

export default getYoutubeId
